// @flow
export { default, Label, SubLabel } from './LabelAndErrorFormGroup';
export type { Props } from './LabelAndErrorFormGroup';



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/LabelAndErrorFormGroup/index.js